export default {
    popups(width, height) {
        var left = 0;
        var top = 0;
        width = width ? width : 0;
        height = height ? height : 0;
        if (width && height) {
            left = (1 - width) / 2;
            top = (1 - height) / 2;
        }
        return {
            overflow: 'hidden',
            left: window.innerWidth * left + "px",
            top: window.innerHeight * top + "px",
            width: window.innerWidth * width + "px",
            height: window.innerHeight * height + "px",
            "min-width": window.innerWidth * width + "px",
            "min-height": window.innerHeight * height + "px",
        }
    },
    harvestRecordStyle(h, add) {
        if (add != 0) {
            add = add ? add : 0.05;
        };
        if (window.innerHeight < 800) {
            h = h
        } else if (window.innerHeight > 800 && window.innerHeight < 1000) {
            h = h + add
        }
        return {
            height: window.innerHeight * h + "px",
            "min-height": window.innerHeight * h + "px",
        }
    }
}